const _import_ = filePath => resolve => {
  return import("@view/" + filePath).then(module => resolve(module));
};
export default _import_;
